/**
 * Created by richardlovejoy on 2/27/17.
 */
/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const BonusCupShimmer = function(game) {

  Phaser.Group.call(this, game);

  // visual
  this.emitter = null;
  this.visible = false;
  this.zone = null;

  this.init();
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
BonusCupShimmer.PARTICLE_DATA_ADDED = false;

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
BonusCupShimmer.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: BonusCupShimmer,

  /**
   *
   */
  init: function() {

    // create emitter
    var manager = this.game.display.particleStorm;
    if (!BonusCupShimmer.PARTICLE_DATA_ADDED) {
      var shimmer = {
        image: 'skee',
        frame: 'efxSparkle1.png',
        lifespan: { min: 600, max: 750 },
        scale: { min: 0.15, max: 0.3 },
        vx: {min: -0.1, max: 0.1},
        vy: {min: -0.1, max: 0.1},
        rotation: {value: {min: 0, max: 90}, delta: {min: -5, max: 5}},
        alpha: { value: 1, control : [ { x: 0, y: 0.7 }, {x: 0.3, y: 1}, {x: 0.8, y: 1}, { x: 1, y: 0 } ] },
        delay: {min: 0, max: 300}
      };

      manager.addData('shimmer', shimmer);

      BonusCupShimmer.PARTICLE_DATA_ADDED = true;
    }

    this.emitter = manager.createEmitter();
    this.emitter.seed(20);
    this.emitter.addToWorld(this);
    this.emitter.enabled = false;

    this.zone = manager.createCircleZone((this.game.device.desktop) ? 25 : 18);

  }, // end Init

  reset: function() {


  },

  run: function() {

    if (this.visible)
      return;

    this.visible = true;

    // this hogs cpu on mobile, so take it down a notch
    this.emitter.enabled = true;
    this.emitter.emit('shimmer', 0, 0, {zone: this.zone, total: (this.game.device.desktop) ? 20 : 8, repeat: -1});


  },

  stop: function() {

    this.emitter.timer.stop();

    setTimeout(() => {
      this.visible = false;
      this.emitter.enabled = false;
    }, 500);

  },

  repeat: function(x, y) {

    //this.emitter.emit('shimmerInner', x, y, {total: 16, repeat: -1, frequency: 1000});
    //this.emitter.emit('shimmerOuter', x, y, {total: 20, repeat: -1, frequency: 1000});

  }

});

export default BonusCupShimmer;





// WEBPACK FOOTER //
// ./app/src/display/effects/BonusCupShimmer.js